// "See RBP links" on a product card (RBP-D33): the Substitute button's variant (Figma has no RBP
// links design; SL1.0 shows the RBP button beside the substitute one, `cabinet_smanager.htm`). On
// an orderable card it is its own full-width row under the footer, so it never squeezes Add or
// Substitute (`RbpLinksCta`); on a not-available card it is the footer's action
// (`RbpLinksButton`). It opens the links page with the product's name in router state.
import { useNavigate } from 'react-router';
import { Button } from '../../design-system';
import { rbpLinksHref, type RbpLinksHandover } from '../../rbp/rbpLinksRoute';
import styles from './ProductCard.module.css';

export interface RbpLinksCtaProps {
  readonly sku: string;
  readonly name: string;
  readonly layout: 'grid' | 'list';
}

export function RbpLinksCta({ sku, name, layout }: RbpLinksCtaProps) {
  return (
    <div
      className={
        layout === 'list' ? `${styles.rbpLinksRow} ${styles.listFullRow}` : styles.rbpLinksRow
      }
    >
      <RbpLinksButton sku={sku} name={name} />
    </div>
  );
}

export function RbpLinksButton({ sku, name }: { readonly sku: string; readonly name: string }) {
  const navigate = useNavigate();
  const handover: RbpLinksHandover = { parentName: name };
  return (
    <Button
      variant="substitute"
      className={styles.rbpLinksCta}
      aria-label={`See RBP links for ${name}`}
      onClick={() => void navigate(rbpLinksHref(sku), { state: handover })}
    >
      See RBP links
    </Button>
  );
}
